import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import defaultAvatar from '../../images/default-avatar.png';

interface Props {
    expert: { firstName: string; lastName?: string; profilePhoto: string | undefined; expertId?: string };
    className?: string;
    width?: string;
    height?: string;
    alt?: string;
}

const errorHandler = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.onerror = null;
    event.currentTarget.src = defaultAvatar;
};

const isFromS3 = (url: string): boolean => {
    return url.indexOf('https://s3') > -1;
};

export default function ExpertAvatar(props: Props) {
    const [profilePhoto, setProfilePhoto] = useState(defaultAvatar);

    useEffect(() => {
        if (props.expert.profilePhoto && isFromS3(props.expert.profilePhoto)) {
            setProfilePhoto(props.expert.profilePhoto);
        }
    }, [props.expert.profilePhoto]);

    return (
        <Img
            src={profilePhoto}
            alt={
                props.alt
                    ? props.alt
                    : `${props.expert.firstName} ${props.expert.lastName ? props.expert.lastName : ''}`
            }
            onError={errorHandler}
            className={props.className ? props.className : undefined}
            {...props}
        />
    );
}

const Img = styled.img<Props>`
    width: ${(props) => (props.width ? props.width : '48px')};
    height: ${(props) => (props.height ? props.height : '48px')};
    border-radius: 50%;
    object-fit: cover;
`;
